<template>
  
  <fieldset class="form-fieldset">
    <legend class="form-label">{{ label }}</legend>
    <div v-if="helpMessage" class="form-help">{{ helpMessage }}</div>
    <p
      v-if="errorMessage"
      class="form-label form-label--error form-label--error--active"
    >{{ errorMessage }}</p>
    <div
      v-for="(item, index) in switchArray"
      :key="`${item.id}-${item.name}`"
      class="form-switch"
      @click="onClick(item, index)"
    >
      <input
        :id="`groupSwitch-${item.id}`"
        type="checkbox"
        class="form-switch__field"
        :name="item.name"
        :checked="item.checked"
        :disabled="item.disabled"
      />
      <label class="form-switch__label" :for="`groupSwitch-${item.id}`">{{ item.label }}</label>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "SwitchGroup",
  props: {
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
    helpMessage: {
      type: String,
      required: true,
    },
    switchArray: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onClick(item, itemIndex) {
      let updatedSwitchArray = this.switchArray.map((item, arrayIndex) => {
        if (arrayIndex === itemIndex) {
          return {
            ...item,
            checked: !item.checked,
          };
        } else {
          return {
            ...item,
          };
        }
      });

      let updatedRadioData = {
        switchCheckedItemLabels: updatedSwitchArray
          .filter((item) => item.checked)
          .map((item) => item.label), // Useful when radio groups are being used with Filters
        switchArray: updatedSwitchArray, // Parent needs to handle the state, child will emit the data based on the clicks
      };
      this.$emit("onClick", updatedRadioData);
    },
  },
};
</script>